import { jsx as _jsx } from "react/jsx-runtime";
import { Badge, pluralRu } from '@wit-support/ui';
import { Gem } from 'lucide-react';
/** Подпись бейджа: с числом списаний, когда оно известно. */
export function whaleBadgeLabel(chargesCount) {
    return chargesCount != null
        ? `Крупный плательщик: ${chargesCount} ${pluralRu(chargesCount, CHARGE_FORMS)}`
        : 'Крупный плательщик';
}
/** «1 списание», «2 списания», «47 списаний». */
const CHARGE_FORMS = ['списание', 'списания', 'списаний'];
/**
 * Отмечает диалог с клиентом, который заплатил нам много раз, — «кит».
 *
 * Рисуется ТОЛЬКО при `isWhale === true` — строгое сравнение, чтобы в окне
 * выката `undefined` от старого admin-api не превратился в бейдж. Промолчать
 * правильнее, чем назвать китом того, про кого ничего не известно.
 *
 * ЦВЕТ ВЫБРАН ОСОЗНАННО. В том же ряду строки инбокса уже стоят красный щит
 * алертов по платежам, красный треугольник упавшего пайплайна и жёлтые часы
 * ожидания — всё это тревога. Кит — не тревога, а ценность клиента, поэтому
 * `success` (зелёный) и самоцвет: оператор не должен читать бейдж как «тут
 * что-то не так». Число списаний уходит в подпись, а не в текст бейджа: рядом
 * в строке уже есть счётчик непрочитанных, и второе число сбивало бы с толку.
 */
export const WhaleBadge = ({ isWhale, chargesCount, settingsHref, size = 'sm', className, }) => {
    if (isWhale !== true)
        return null;
    const label = whaleBadgeLabel(chargesCount);
    const icon = _jsx(Gem, { className: size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5', "aria-hidden": "true" });
    if (settingsHref) {
        // Со ссылкой роль меняется с `img` на ссылку, и подпись становится её
        // доступным именем: «Крупный плательщик: 47 списаний» ведёт туда, где это
        // число объясняется. Читателю с экрана объявляется ссылка, а не картинка.
        return (_jsx("a", { href: settingsHref, title: label, "aria-label": label, className: "inline-flex rounded-[var(--radius-1)] outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-border-focus)]", children: _jsx(Badge, { variant: "success", size: size, className: className, children: icon }) }));
    }
    return (_jsx(Badge, { variant: "success", size: size, className: className, title: label, "aria-label": label, role: "img", children: icon }));
};
WhaleBadge.displayName = 'WhaleBadge';
//# sourceMappingURL=whale-badge.js.map